var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0278 0 55.3 61.9688",
    width: 55.3,
    height: 61.9688,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 168.99888610839844, 119.2276840209961)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 10,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 2,
    x: 31,
    y: 38
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 2,
    x: 53,
    y: 21
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 0.1782 27.6652)",
    width: 2,
    x: 50.722,
    y: 12.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 16.451 43.0455)",
    width: 2,
    x: 44.5,
    y: 6.277
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 2,
    x: 36,
    y: 4
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -12.2646 27.6645)",
    width: 2,
    x: 44.5,
    y: 35.722
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -0.5497 60.048)",
    width: 2,
    x: 50.722,
    y: 29.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 7,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 2,
    x: 35,
    y: 38
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 5,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 2,
    x: 39,
    y: 38
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-1, 0, 0, 1, -109.999023, -120.227684)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 22,
    r: 13,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(-0.999497, 0, 0, 0.999497, -110.00087, -120.22718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.03,50.242L53.719,53h-2.82c-0.279-1.37-1.128-2.525-2.278-3.239L55,47.731V34.296    c2.682-3.71,4.148-8.268,3.988-13.024C58.61,10.095,48.964,1,37.486,1h-6.706c-3.474,0-6.685,0.699-9.542,2.079    C13.69,6.724,9,14.16,9,22.485c0,2.563-1.148,4.953-3.15,6.554l-2.178,1.742l0.486,0.759c3.348,5.222,5.831,10.914,7.38,16.92    l0.312,1.211c0.538,2.083,1.875,3.773,3.67,4.639c0.949,0.458,1.977,0.686,3.002,0.686c1.124,0,2.245-0.273,3.254-0.82    l14.997-8.124c2.593-1.403,5.304-2.709,7.927-3.972c0.83-0.399,1.66-0.799,2.488-1.202c2.205-1.074,4.155-2.512,5.812-4.208v9.6    l-20,6.364V51h-2v12h27.281L54.97,49.758L53.03,50.242z M46.312,39.078c-0.825,0.402-1.652,0.801-2.479,1.199    c-2.644,1.272-5.377,2.588-8.011,4.016l-14.997,8.123c-1.365,0.74-3.023,0.772-4.435,0.093c-1.264-0.609-2.212-1.826-2.602-3.338    l-0.312-1.211c-0.083-0.322-0.179-0.64-0.267-0.96H16v-2h-3.38c-1.514-4.838-3.619-9.46-6.298-13.777l0.776-0.621    C9.578,28.618,11,25.66,11,22.485c0-7.552,4.256-14.297,11.108-17.605C24.692,3.633,27.61,3,30.781,3H31v6.37    c-4.722,2.253-8,7.059-8,12.63c0,7.72,6.28,14,14,14s14-6.28,14-14S44.72,8,37,8c-1.39,0-2.731,0.21-4,0.59V3h4.486    c10.412,0,19.161,8.228,19.502,18.341C57.242,28.832,53.051,35.795,46.312,39.078z M27.845,14.259l2.13,2.13    C28.742,17.929,28,19.878,28,22s0.742,4.071,1.975,5.611l-2.13,2.13C26.074,27.649,25,24.949,25,22S26.074,16.351,27.845,14.259z     M44,22c0,3.859-3.14,7-7,7s-7-3.141-7-7s3.14-7,7-7S44,18.141,44,22z M31.389,29.025C32.93,30.258,34.878,31,37,31    s4.07-0.742,5.611-1.975l2.13,2.13C42.649,32.926,39.949,34,37,34s-5.649-1.074-7.741-2.845L31.389,29.025z M46.155,29.741    l-2.13-2.13C45.258,26.071,46,24.122,46,22s-0.742-4.071-1.975-5.611l2.13-2.13C47.926,16.351,49,19.051,49,22    S47.926,27.649,46.155,29.741z M42.611,14.975C41.07,13.742,39.122,13,37,13s-4.07,0.742-5.611,1.975l-2.13-2.13    C31.351,11.074,34.051,10,37,10s5.649,1.074,7.741,2.845L42.611,14.975z M55.347,59.51l-4.745-3.558    c0.129-0.303,0.229-0.622,0.297-0.952h3.32L55.347,59.51z M46.363,58.963L47.382,61h-8.66l6.713-2.043l-0.004-0.015    C45.619,58.964,45.805,59,46,59C46.124,59,46.241,58.972,46.363,58.963z M48.319,58.403c0.416-0.22,0.804-0.484,1.14-0.808L54,61    h-4.382L48.319,58.403z M46,57c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S47.654,57,46,57z M41.392,52.061    C41.14,52.658,41,53.313,41,54c0,1.475,0.655,2.79,1.674,3.706L33,60.65v-5.919L41.392,52.061z",
    style: {
      fill: "rgb(255, 0, 43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,17c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S39.757,17,37,17z M37,25    c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S38.654,25,37,25z",
    style: {
      fill: "rgb(255, 0, 43)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 7,
    x: 13,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "rgb(255, 0, 43)"
    },
    width: 2,
    x: 45,
    y: 53
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotAi);
export default __webpack_public_path__ + "static/media/robot_ai.d2ebe216405bf0e90ba1dfa69254301b.svg";
export { ForwardRef as ReactComponent };